/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_BodyInputs */

const cs_import_done_body = /** @type {(inputs: Import_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import dokončen. Exporty na portály zůstávají vypnuté, dokud je nezapnete u inzerátů.`)
};

const en_import_done_body = /** @type {(inputs: Import_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import finished. Portal exports stay off until you enable them per listing.`)
};

/**
* | output |
* | --- |
* | "Import finished. Portal exports stay off until you enable them per listing." |
*
* @param {Import_Done_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_body = /** @type {((inputs?: Import_Done_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_body(inputs)
	return cs_import_done_body(inputs)
});